import Hero from "./Hero";
import Footer from "../Layout/Footer";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

const Login = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("msg") === "success") {
      toast.success(
        "You will get username and password on your mobile and email. تم ارسال اسم المستخدم وكلمة المرور  الى رقم الموبايل والبريد الالكتروني",
        { toastId: "success-msg" }
      );
    } else if (searchParams.get("msg") === "paid") {
      toast.success("شكرا لاختيارك جامعة بيت لحم", { toastId: "success-msg" });
    }
  }, [searchParams]);

  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        className={"notification"}
      />
      <Hero />
      <Footer />
    </>
  );
};

export default Login;
